import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { UnAuthorizedComponent } from './pages/errors/un-authorized/un-authorized.component';
import { AuthGuard } from './services/auth/auth.guard';
import { RoleGuard } from './services/auth/role.guard';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: './pages/dashboard/dashboard.module#DashboardModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR']
        }
      },
      {
        path: 'assets',
        loadChildren: './pages/assets/assets.module#AssetsModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR']
        }
      },
      {
        path: 'routes',
        loadChildren: './pages/routes/routes.module#RoutesModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR']
        }
      },
      {
        path: 'customers',
        loadChildren: './pages/customers/customers.module#CustomersModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN']
        }
      },
      {
        path: 'analytics',
        loadChildren: './pages/analytics/analytics.module#AnalyticsModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN']
        }
      },
      {
        path: 'companies',
        loadChildren: './pages/companies/companies.module#CompaniesModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN']
        }
      },
      {
        path: 'devices',
        loadChildren: './pages/devices/devices.module#DevicesModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN']
        }
      },
      {
        path: 'locations',
        loadChildren: './pages/location/location.module#LocationModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR']
        }
      },
      {
        path: 'schedule-trips',
        loadChildren: './pages/schedule-trips/schedule-trips.module#ScheduleTripsModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR']
        }
      },
      {
        path: 'shipments',
        loadChildren: './pages/shipments/shipments.module#ShipmentsModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR']
        }
      },
      {
        path: 'users',
        loadChildren: './pages/users/users.module#UsersModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATOR']
        }
      },
      {
        path: 'settings',
        loadChildren: './pages/settings/settings.module#SettingsModule',
        canActivate: [RoleGuard],
        data: {
          allowed_roles: ['ADMIN']
        }
      },
      {
        path: 'error/403',
        component: UnAuthorizedComponent
      },
      {
        path: 'error/404',
        component: NotFoundComponent
      }
    ]
  },
  {
    path: 'login',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadChildren: './pages/auth/auth.module#AuthModule'
      }
    ]
  },
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadChildren: './pages/auth/auth.module#AuthModule'
      }
    ]
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts